import { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import { appEnv } from 'src/util/appEnv'

/**
 * GoogleTagManagerにuserIdを設定する
 */
export const useSetGtmUserId = (userUuid: string | undefined) => {
  useEffect(() => {
    if (userUuid && !appEnv.isLocal) {
      TagManager.dataLayer({
        dataLayer: {
          userId: userUuid,
        },
      })
    }
  }, [userUuid])
}
